import React, { useState, useEffect } from "react";
import { Container, Accordion, Modal } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BackButton from "../../../../components/UI_Kit/BackButton/BackButton";
import api from "../../../../services/api";
import "./style.css";
import GoogleMapDisplay from "../../../../components/GoogleMapDisplay/GoogleMapDisplay";
import priceListData from "../../../../components/priceListData.json";

const calculatePricesFromConfiguration = (points, priceList) => {
  let totalMonthlyRent = 0;
  let totalSalePrice = 0;

  console.log("Available keys in priceList:", Object.keys(priceList));

  points.forEach(point => {
    console.log("Processing point:", point);
    console.log("Point type:", point.type);

    // Map point types to JSON structure
    const pointTypeMap = {
      'vision_point': 'Nouveau_point_de_vision',
      'relay_point': 'Point_Relais',
      'high_point': 'Point_Haut',
      'surveillance_center': 'Centre_de_surveillance'
    };

    const jsonPointType = pointTypeMap[point.type] || 'Nouveau_point_de_vision';
    console.log("Looking for JSON point type:", jsonPointType);

    // Normalize search for point type
    const normalizedJsonPointType = normalizeKey(jsonPointType);
    let pointData = findKeyCaseInsensitive(priceList, normalizedJsonPointType);

    if (!pointData) {
      console.log("No point data found for:", jsonPointType);
      return;
    }

    // Calculate support equipment prices
    const supportType = normalizeKey(point.support_type || "");
    console.log("Looking for support type:", supportType, "in", Object.keys(pointData.Type_de_support || {}));

    if (pointData.Type_de_support) {
      const supportData = findKeyCaseInsensitive(pointData.Type_de_support, supportType);
      if (supportData) {
        supportData.forEach(item => {
          totalMonthlyRent += item.prix_a_la_Loc || 0;
          totalSalePrice += item.Prix_a_la_Vente || 0;
          console.log("Added support item:", item.Reference, "- Rent:", item.prix_a_la_Loc, "- Sale:", item.Prix_a_la_Vente);
        });
      }
    }

    // Calculate connection equipment prices  
    const connectionType = normalizeKey(point.connection_type || "");
    console.log("Looking for connection type:", connectionType, "in", Object.keys(pointData.Type_de_Liaison || {}));

    if (pointData.Type_de_Liaison) {
      const connectionData = findKeyCaseInsensitive(pointData.Type_de_Liaison, connectionType);
      if (connectionData) {
        connectionData.forEach(item => {
          totalMonthlyRent += item.prix_a_la_Loc || 0;
          totalSalePrice += item.Prix_a_la_Vente || 0;
          console.log("Added connection item:", item.Reference, "- Rent:", item.prix_a_la_Loc, "- Sale:", item.Prix_a_la_Vente);
        });
      }
    }

    // Calculate power equipment prices
    // Calculate power equipment prices
    const powerType = normalizeKey(point.power_type || "");
    console.log("Looking for power type:", powerType, "in", Object.keys(pointData.Type_d_Alimentation || {}));

    if (pointData.Type_d_Alimentation) {
      const powerData = findKeyCaseInsensitive(pointData.Type_d_Alimentation, powerType);
      if (powerData) {
        if (powerData.length === 0) {
          console.log("🔍 POWER TYPE FOUND BUT EMPTY:", powerType, "- No items to price");
        } else {
          powerData.forEach(item => {
            totalMonthlyRent += item.prix_a_la_Loc || 0;
            totalSalePrice += item.Prix_a_la_Vente || 0;
            console.log("Added power item:", item.Reference, "- Rent:", item.prix_a_la_Loc, "- Sale:", item.Prix_a_la_Vente);
          });
        }
      } else {
        console.log("❌ POWER TYPE NOT FOUND:", powerType);
      }
    }

    // Calculate camera equipment prices (for vision points)
    point.cameras?.forEach(camera => {
      const cameraRole = normalizeKey(camera?.role || "");
      console.log("Looking for camera role:", cameraRole, "in", Object.keys(pointData.Constitution_du_point?.Role_de_la_Camera || {}));

      if (pointData.Constitution_du_point?.Role_de_la_Camera) {
        const cameraData = findKeyCaseInsensitive(pointData.Constitution_du_point.Role_de_la_Camera, cameraRole);
        if (cameraData) {
          cameraData.forEach(item => {
            totalMonthlyRent += item.prix_a_la_Loc || 0;
            totalSalePrice += item.Prix_a_la_Vente || 0;
            console.log("Added camera item:", item.Reference, "- Rent:", item.prix_a_la_Loc, "- Sale:", item.Prix_a_la_Vente);
          });
        }
      }
    });

    // Calculate coverage area equipment (for high points)
    const coverageArea = normalizeKey(point.coverage_area?.replace(/°/g, "") || "");
    console.log("Looking for coverage area:", coverageArea, "in", Object.keys(pointData.Zone_de_couverture || {}));

    if (pointData.Zone_de_couverture) {
      const coverageData = findKeyCaseInsensitive(pointData.Zone_de_couverture, coverageArea);
      if (coverageData) {
        coverageData.forEach(item => {
          totalMonthlyRent += item.prix_a_la_Loc || 0;
          totalSalePrice += item.Prix_a_la_Vente || 0;
          console.log("Added coverage item:", item.Reference, "- Rent:", item.prix_a_la_Loc, "- Sale:", item.Prix_a_la_Vente);
        });
      }
    }

    // Calculate recorder equipment (for surveillance centers)
    const recorderSize = normalizeKey(point.recorder_size || "");
    console.log("Looking for recorder size:", recorderSize, "in", Object.keys(pointData.Taille_de_l_enregistreur || {}));

    if (pointData.Taille_de_l_enregistreur) {
      const recorderData = findKeyCaseInsensitive(pointData.Taille_de_l_enregistreur, recorderSize);
      if (recorderData) {
        recorderData.forEach(item => {
          totalMonthlyRent += item.prix_a_la_Loc || 0;
          totalSalePrice += item.Prix_a_la_Vente || 0;
          console.log("Added recorder item:", item.Reference, "- Rent:", item.prix_a_la_Loc, "- Sale:", item.Prix_a_la_Vente);
        });
      }
    }

    // Calculate screen equipment (for surveillance centers)
    const screenSize = normalizeKey(point.screen_size || "");
    console.log("Looking for screen size:", screenSize, "in", Object.keys(pointData.Taille_de_l_ecran || {}));

    if (pointData.Taille_de_l_ecran) {
      const screenData = findKeyCaseInsensitive(pointData.Taille_de_l_ecran, screenSize);
      if (screenData) {
        screenData.forEach(item => {
          totalMonthlyRent += item.prix_a_la_Loc || 0;
          totalSalePrice += item.Prix_a_la_Vente || 0;
          console.log("Added screen item:", item.Reference, "- Rent:", item.prix_a_la_Loc, "- Sale:", item.Prix_a_la_Vente);
        });
      }
    }
  });

  console.log("Final totals - Monthly Rent:", totalMonthlyRent, "Sale Price:", totalSalePrice);

  return {
    monthlyRent: parseFloat(totalMonthlyRent.toFixed(2)),
    salePrice: parseFloat(totalSalePrice.toFixed(2)),
    originalMonthlyRent: parseFloat(totalMonthlyRent.toFixed(2)),
    originalSalePrice: parseFloat(totalSalePrice.toFixed(2))
  };
};

// Helper function to normalize keys for consistent searching
const normalizeKey = (key) => {
  return key
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks first
    .toLowerCase() // Then convert to lowercase
    .replace(/\+/g, 'plus')
    .replace(/'/g, '_') // Replace apostrophe with underscore
    .replace(/-/g, '_')
    .replace(/ /g, '_')
    .replace(/°/g, '')
    .replace(/^_+|_+$/g, '') // Trim underscores
    .replace(/_+/g, '_'); // Collapse multiple underscores
};

// Helper function for case-insensitive key search
const findKeyCaseInsensitive = (obj, targetKey) => {
  if (!obj) return null;

  const normalizedTarget = normalizeKey(targetKey);

  for (const key of Object.keys(obj)) {
    const normalizedKey = normalizeKey(key);
    if (normalizedKey === normalizedTarget) {
      return obj[key];
    }
  }
  return null;
};

const Summary = () => {

  const navigate = useNavigate();
  const { id } = useParams();

  // Pricing states
  const [isLeasingChecked, setIsLeasingChecked] = useState(false);
  const [isAchatChecked, setIsAchatChecked] = useState(false);
  const [monthlyRent, setMonthlyRent] = useState(0);
  const [soldPrice, setSoldPrice] = useState(0);
  const [originalMonthlyRent, setOriginalMonthlyRent] = useState(0);
  const [originalSalePrice, setOriginalSalePrice] = useState(0);
  // selectedMonths is a fixed value of 72 months as per business requirement.
  const selectedMonths = 72;

  // Opportunity states
  const [showOpportunity, setShowOpportunity] = useState(false);
  const [opportunityAmount, setOpportunityAmount] = useState(0);
  const [validityDate, setValidityDate] = useState("");

  // Calculated values
  const [totalPurchaseHT, setTotalPurchaseHT] = useState(0);
  const [purchaseRemise, setPurchaseRemise] = useState(0);
  const [totalPurchaseTTC, setTotalPurchaseTTC] = useState(0);
  const [monthlyRentTTC, setMonthlyRentTTC] = useState(0);
  const [leasingRemise, setLeasingRemise] = useState(0);

  // Data states
  const [points, setPoints] = useState([]);
  const [quotation, setQuotation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Map modal states
  const [showMapModal, setShowMapModal] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedPointTitle, setSelectedPointTitle] = useState([]);
  const [countdown, setCountdown] = useState(3);


  // Auto-redirect when no points
  useEffect(() => {
    if (points && points.length === 0) {
      setCountdown(3);
      const interval = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      const redirectTimer = setTimeout(() => {
        navigate(`/invoice/create/step2/${id}`);
      }, 3000);
      return () => {
        clearTimeout(redirectTimer);
        clearInterval(interval);
      };
    }
  }, [navigate, id, points]);

  // Handle input change
  const handleMonthlyRentChange = (value) => {
    const updatedValue = parseFloat(value) || 0;
    setMonthlyRent(updatedValue);
  };
  const handleSoldPriceChange = (value) => {
    const updatedValue = parseFloat(value) || 0;
    setSoldPrice(updatedValue);
  };

  // Calculate purchase prices (realtime)
  useEffect(() => {
    if (isAchatChecked && quotation) {
      setTotalPurchaseHT(originalSalePrice);
      const baseHT = parseFloat(originalSalePrice) || 0;
      const soldHT = parseFloat(soldPrice) || 0;
      const tvaPercent = parseFloat(quotation.vat) || 20;

      // Remise %
      const remisePercent = baseHT > 0 ? ((soldHT / baseHT) - 1) * 100 : 0;
      setPurchaseRemise(remisePercent);

      // Prix total TTC
      setTotalPurchaseTTC(soldHT * (1 + tvaPercent / 100));
    }
  }, [isAchatChecked, soldPrice, originalSalePrice, quotation]);

  // Calculate Leasing price (realtime)
  useEffect(() => {
    if (isLeasingChecked && quotation) {
      const baseHT = parseFloat(originalMonthlyRent) || 0;
      const soldHT = parseFloat(monthlyRent) || 0;
      const tvaPercent = parseFloat(quotation.vat) || 20;

      // console.log("baseHT : ", baseHT)
      // console.log("soldHT : ", soldHT)
      // console.log('showOpportunity : ', showOpportunity)
      // console.log('monthlyRentTTC : ', monthlyRentTTC)
      // Remise %
      const remisePercent = showOpportunity && monthlyRentTTC > 0
        ? ((opportunityAmount / baseHT) - 1) * 100
        : (baseHT > 0 ? ((soldHT / baseHT) - 1) * 100 : 0);
      setLeasingRemise(remisePercent);

      // Loyer TTC
      setMonthlyRentTTC(soldHT * (1 + tvaPercent / 100));
    }
  }, [isLeasingChecked, monthlyRent, originalMonthlyRent, quotation, showOpportunity, opportunityAmount, monthlyRentTTC]);

  // Fetch quotation data
  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("access_token");
        const response = await api.get(`/quotation/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const fetchedQuotation = response.data.quotation;
        setQuotation(fetchedQuotation);
        setPoints(fetchedQuotation.points || []);

        // Helper function to check for null or "NULL" string
        const isNullValue = (value) => value === null || String(value).toUpperCase() === "NULL";

        // Update display fields based on API response
        let initialMonthlyRent = 0;
        let initialSoldPrice = 0;
        let initialOriginalMonthlyRent = 0;
        let initialOriginalSalePrice = 0;

        // Auto-calculate prices based on configuration
        if (fetchedQuotation.points && fetchedQuotation.points.length > 0) {
          const calculatedPrices = calculatePricesFromConfiguration(
            fetchedQuotation.points,
            priceListData
          );

          initialOriginalMonthlyRent = calculatedPrices.monthlyRent;
          initialOriginalSalePrice = calculatedPrices.salePrice;

          // Set sold rent, defaulting to original if not provided by API
          if (!isNullValue(fetchedQuotation.rent_ht_monthly_sold)) {
            const parsedValue = parseFloat(fetchedQuotation.rent_ht_monthly_sold);
            initialMonthlyRent = isNaN(parsedValue) ? 0 : parsedValue;
          } else {
            initialMonthlyRent = calculatedPrices.monthlyRent;
          }

          // Set sold price, defaulting to original if not provided by API
          if (!isNullValue(fetchedQuotation.purchase_price_ht_sold)) {
            const parsedValue = parseFloat(fetchedQuotation.purchase_price_ht_sold);
            initialSoldPrice = isNaN(parsedValue) ? 0 : parsedValue;
          } else {
            initialSoldPrice = calculatedPrices.salePrice;
          }
        }

        setOriginalMonthlyRent(initialOriginalMonthlyRent);
        setOriginalSalePrice(initialOriginalSalePrice);
        setMonthlyRent(initialMonthlyRent);
        setSoldPrice(initialSoldPrice);

        // Set existing pricing configuration
        const pricingMap = {
          purchase: { leasing: false, achat: true },
          leasing: { leasing: true, achat: false },
          purchase_and_leasing: { leasing: true, achat: true },
        };

        const { leasing = false, achat = false } = pricingMap[fetchedQuotation?.pricing] || {};
        setIsLeasingChecked(leasing);
        setIsAchatChecked(achat);

        const isOpportunityProposed = fetchedQuotation?.is_oportunity_proposed || false;
        setShowOpportunity(isOpportunityProposed);
        setValidityDate(fetchedQuotation?.oportunity_expire_at || "");

        let initialOpportunityAmount = parseFloat(fetchedQuotation?.opportunity_amount) || 0;
        console.log("initialOpportunityAmount : " , initialOpportunityAmount)
        // If opportunity is proposed but amount is 0, default to the resolved initialMonthlyRent
        if (isOpportunityProposed && initialOpportunityAmount === 0) {
          initialOpportunityAmount = 0;
        }
        setOpportunityAmount(initialOpportunityAmount);

      } catch (err) {
        setError("Failed to fetch quotation data");
        toast.error("Failed to fetch quotation data");
        // console.error("Error fetching quotation:", err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchQuotation();
    } else {
      setError("Quotation ID is missing.");
      setLoading(false);
    }
  }, [id]);

  const handleValidate = async () => {
    const data = {
      leasing: isLeasingChecked,
      achat: isAchatChecked,
      rental_months: selectedMonths,
      rent_ht_monthly_sold: monthlyRent,
      is_oportunity_proposed: isAchatChecked && !isLeasingChecked ? false : showOpportunity,
      purchase_price_ht_sold: isAchatChecked ? soldPrice : 0,
      oportunity_expire_at: isAchatChecked && !isLeasingChecked ? null : (showOpportunity ? validityDate : null),
      annual_maintenance : (soldPrice * 0.10).toFixed(2),
      opportunity_amount: isAchatChecked && !isLeasingChecked ? 0 : (showOpportunity ? opportunityAmount : 0),
      discount: isAchatChecked ? purchaseRemise : (isLeasingChecked ? leasingRemise : 0),
    };
console.log(data)
    try {
      setLoading(true);
      const response = await api.post(`/quotation-ask-for-validation/${id}`, data);
      if (response.data.email_sent === false) {
        toast.warn(response.data.message);
      } else {
        toast.success("Demande de validation envoyée avec succès !");
      }
      // navigate("/");
    } catch (err) {
      setError("Échec de la validation du devis");
      toast.error("Échec de la validation du devis");
    } finally {
      setLoading(false);
    }
  };

  const handleDraft = async () => {
    const data = {
      leasing: isLeasingChecked,
      achat: isAchatChecked,
      rental_months: selectedMonths,
      rent_ht_monthly_sold: monthlyRent,
      is_oportunity_proposed: isAchatChecked && !isLeasingChecked ? false : showOpportunity,
      purchase_price_ht_sold: showOpportunity ? opportunityAmount : soldPrice,
      oportunity_expire_at: isAchatChecked && !isLeasingChecked ? null : (showOpportunity ? validityDate : null),
      opportunity_amount: isAchatChecked && !isLeasingChecked ? 0 : (showOpportunity ? opportunityAmount : 0),
      status: "draft",
    };

    try {
      setLoading(true);
      const token = localStorage.getItem("access_token");
      await api.patch(`/quotation/${id}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Devis sauvegardé en tant que brouillon.");
      navigate("/");
    } catch (err) {
      setError("Échec de la sauvegarde du brouillon");
      toast.error("Échec de la sauvegarde du brouillon");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenMapModal = (point) => {
    if (point.localisations && point.localisations.length > 0) {
      setSelectedLocations(point.localisations);
      setSelectedPointTitle([point.full_type, point.title]);
      setShowMapModal(true);
    } else {
      toast.info("Aucune localisation disponible pour ce point");
    }
  };

  const handleCloseMapModal = () => {
    setShowMapModal(false);
    setSelectedLocations([]);
    setSelectedPointTitle("");
  };

  const handleEditPoint = (index) => {
    const pointToEdit = points[index];
    const apiPointType = pointToEdit.type || pointToEdit.pointType;
    const dataForEdit = {
      id: pointToEdit.id,
      title: pointToEdit.title || pointToEdit.pointName,
      type: apiPointType,
      support_type: pointToEdit.support_type || pointToEdit.supportType,
      connection_type: pointToEdit.connection_type || pointToEdit.installationType,
      power_type: pointToEdit.power_type || pointToEdit.powerSupplyType,
      comment: pointToEdit.comment || "",
      has_camera: pointToEdit.has_camera,
      cameras: pointToEdit.cameras || [],
      localisations: pointToEdit.localisations || [],
      recorder_size: pointToEdit.recorder_size || pointToEdit.recorderSize,
      screen_size: pointToEdit.screen_size || pointToEdit.screenSize,
      coverage_area: pointToEdit.coverage_area || pointToEdit.coverageArea,
    };
    navigate("/invoice/edit-point", {
      state: { pointToEdit: dataForEdit, quotationId: quotation?.id },
    });
  };

  const capitalizeFirstLetter = (string) => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
  };

  return (
    <HelmetProvider>
      <ToastContainer />
      <Helmet>
        <title>Récapitulatif des Points</title>
        <meta name="description" content="Récapitulatif des points ajoutés" />
      </Helmet>

      <Container className="pt-4 d-flex justify-content-center">
        <div className="container-wrap w-100">
          <div className="header d-flex align-items-center">
            <BackButton className="back-button" />
            <span className="step-title">Récapitulatif des Points</span>
          </div>

          <div className="step_bar d-flex justify-content-between align-items-center w-100">
            <img className="step-image img-fluid" src="/step_done.png" alt="step1" />
            <img className="step-image img-fluid" src="/step_done.png" alt="step2" />
            <img className="step-image img-fluid" src="/step_done.png" alt="step3" />
          </div>

          {loading ? (
            <div className="container">
              <Skeleton height={30} style={{ marginBottom: "1rem" }} />
              <Skeleton height={20} style={{ marginBottom: "3rem" }} />
              <Skeleton height={100} count={4} style={{ marginBottom: "1rem" }} />
            </div>
          ) : (
            <>
              {quotation && (
                <div className="quotation-info mb-2">
                  <h3 className="quotation-number">DEVIS N° {quotation.quotation_number}</h3>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="date-time">
                      Date : {new Date(quotation.created_at).toLocaleDateString("fr-FR", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </span>
                    <div className={`status-badge-custom status-${capitalizeFirstLetter(quotation.status)}`}>
                      <div className="status-content">
                        <span className={`status-badge-dot`}></span>
                        <span className="status-text">
                          {capitalizeFirstLetter(quotation.translated_status)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {points.length === 0 ? (
                    <div className="alert alert-info">
                      Aucun point n'a été ajouté à ce devis.<br />
                      <small>Redirection dans {countdown}...</small>
                    </div>
                  ) : (
                    <>
                      <h4 className="invoice-subtitle">Type de point</h4>
                      <Accordion defaultActiveKey="null" className="points-accordion">
                        {points.slice().reverse().map((point, reversedIndex) => {
                          const index = points.length - 1 - reversedIndex;
                          return (
                            <Accordion.Item key={index} eventKey={index.toString()} className="mb-3">
                              <Accordion.Header>
                                <div>
                                  <div className="header-title">{point.full_type || point.pointType}</div>
                                  <div className="header-subtitle">{point.title || point.pointName}</div>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body>
                                <div className="point-detail mb-3">
                                  <div className="header-title">Type de support:</div>
                                  <div className="header-subtitle">{point.support_type || point.supportType}</div>
                                </div>
                                <div className="point-detail mb-3">
                                  <div className="header-title">Type de liaison:</div>
                                  <div className="header-subtitle">{point.connection_type || point.installationType}</div>
                                </div>
                                <div className="point-detail mb-3">
                                  <div className="header-title">Type d'alimentation:</div>
                                  <div className="header-subtitle">{point.power_type || point.powerSupplyType}</div>
                                </div>

                                {(point.type === "surveillance_center" || point.pointType === "surveillance_center") && (
                                  <>
                                    <div className="point-detail mb-3">
                                      <div className="header-title">Taille de l'enregistreur:</div>
                                      <div className="header-subtitle">{point.recorder_size || point.recorderSize}</div>
                                    </div>
                                    <div className="point-detail mb-3">
                                      <div className="header-title">Taille de l'écran:</div>
                                      <div className="header-subtitle">{point.screen_size || point.screenSize}</div>
                                    </div>
                                  </>
                                )}

                                {(point.type === "high_point" || point.pointType === "high_point") && (
                                  <div className="point-detail mb-3">
                                    <div className="header-title">Zone de couverture:</div>
                                    <div className="header-subtitle">{point.coverage_area || point.coverageArea}</div>
                                  </div>
                                )}

                                {point.comment && (
                                  <div className="point-detail mb-3">
                                    <div className="header-title">Commentaire:</div>
                                    <div className="header-subtitle">{point.comment}</div>
                                  </div>
                                )}

                                <div className="localisations mt-3">
                                  <a href="#OpenMaps" className="SeeAllLocatiion" onClick={() => handleOpenMapModal(point)}>
                                    <img src="/map_location.png" alt="Map Location" style={{ width: "24px", marginRight: "8px" }} />
                                    Voir les localisations
                                  </a>
                                </div>

                                <a href="#" onClick={(e) => { e.preventDefault(); handleEditPoint(index); }} className="mt-4 EditPoint">
                                  <img src="/edit_alt.png" alt="Edit" style={{ width: "24px", marginRight: "8px" }} />
                                  Modifier le point
                                </a>
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        })}
                      </Accordion>

                      <div className="tarification-section mt-3">
                        <h4 className="invoice-subtitle">Tarification</h4>
                        <div className="d-flex mb-3">
                          <div className="checkbox-label custom-checkbox me-4">
                            <input type="checkbox" id="leasing" checked={isLeasingChecked} onChange={(e) => setIsLeasingChecked(e.target.checked)} />
                            <label className="checkbox-label" htmlFor="leasing">Leasing</label>
                          </div>
                          <div className="checkbox-label custom-checkbox me-4">
                            <input type="checkbox" id="achat" checked={isAchatChecked} onChange={(e) => setIsAchatChecked(e.target.checked)} />
                            <label className="checkbox-label" htmlFor="achat">Achat</label>
                          </div>
                        </div>

                        {isLeasingChecked && (
                          <div>
                            <div className="mb-2 d-flex justify-content-between">
                              <span className="tarification-small-title">Loyer total HT</span>
                              <span className="tarification-small-title">{originalMonthlyRent.toFixed(2)} €</span>
                            </div>
                            <div className="mb-4">
                              <span className="monthly-rent-container">
                                <span className="tarification-bold-title monthly-rent-label">Loyer HT mensuel vendu</span>
                                <div className="monthly-rent-input-group d-flex align-items-center gap-2">
                                  <div style={{ width: "200px" }}>
                                    <select className="form-select tarification-small-title" value={selectedMonths} disabled>
                                      <option value={72}>72 mois</option>
                                    </select>
                                  </div>
                                  <input
                                    className="tarification-small-title form-control monthly-rent-input"
                                    value={monthlyRent}
                                    onChange={(e) => handleMonthlyRentChange(e.target.value)}
                                    min="0"
                                    step="0.01"
                                  />
                                  <span className="tarification-small-title monthly-rent-suffix">€/mois</span>
                                </div>
                              </span>
                            </div>
                          </div>
                        )}

                        {isLeasingChecked && !isAchatChecked && (
                          <>
                            <div className="checkbox-label custom-checkbox mb-4">
                              <input type="checkbox" id="opportunite" checked={showOpportunity} onChange={(e) => {
                              const isChecked = e.target.checked;
                              setShowOpportunity(isChecked);
                              if (isChecked) {
                                // opportunityAmount is now independent, so we don't set it here
                              } else if (!isChecked) {
                                setOpportunityAmount(0);
                              }
                            }} />
                              <label className="checkbox-label" htmlFor="opportunite">Opportunité proposée</label>
                            </div>
                            {showOpportunity && (
                              <>
                                <div className="mb-3">
                                  <label htmlFor="opportunityAmount" className="form-label">Montant vendu avec opportunité</label>
                                  <div className="monthly-rent-input-group d-flex align-items-center gap-2">
                                    <input type="text" className="form-control tarification-small-title monthly-rent-input" id="opportunityAmount" value={opportunityAmount} onChange={(e) => setOpportunityAmount(e.target.value)} />
                                    <span className="tarification-small-title monthly-rent-suffix">€</span>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <label htmlFor="validityDate" className="form-label">Date de validité</label>
                                  <div className="monthly-rent-input-group d-flex align-items-center gap-2">
                                    <input type="date" className="form-control tarification-small-title monthly-rent-input" id="validityDate" value={validityDate} onChange={(e) => setValidityDate(e.target.value)} />
                                    <span className="tarification-small-title monthly-rent-suffix">
                                      <img src="/calendar.png" style={{ width: "24px" }} alt="calendar" />
                                    </span>
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )}

                        {(isLeasingChecked) && (
                          <>
                            <div className="mt-3 mb-4 d-flex justify-content-between">
                              <span className="tarification-small-title" style={{ color: leasingRemise.toFixed(0) < -12 || leasingRemise.toFixed(0) > 0 ? 'red' : 'inherit' }}>Remise</span>
                              <span
                                className="tarification-small-title"
                                style={{ color: leasingRemise.toFixed(0) < -12 || leasingRemise.toFixed(0) > 0 ? 'red' : 'inherit' }}
                              >
                                {leasingRemise.toFixed(2)} %
                              </span>
                            </div>
                            <div className="mb-4 d-flex justify-content-between">
                              <span className="tarification-small-title">TVA</span>
                              <span className="tarification-small-title">{quotation.vat} %</span>
                            </div>
                            <hr />
                          </>
                        )}
                        {isAchatChecked && (
                          <div className="mb-4">
                            <div className="mb-2 d-flex justify-content-between">
                              <span className="tarification-small-title">Prix d'achat total HT</span>
                              <span className="tarification-small-title">{totalPurchaseHT.toFixed(2)} €</span>
                            </div>
                            <div className="mb-4">
                              <span className="monthly-rent-container">
                                <span className="tarification-bold-title monthly-rent-label">Prix d'achat HT vendu</span>
                                <div className="monthly-rent-input-group d-flex align-items-center gap-2">
                                  <input type="text" className="form-control tarification-small-title monthly-rent-input" value={soldPrice} onChange={(e) => handleSoldPriceChange(e.target.value)} />
                                  <span className="tarification-small-title monthly-rent-suffix">€</span>
                                </div>
                              </span>
                            </div>
                          </div>
                        )}

                        {(isAchatChecked) && (
                          <>
                            <div className="mt-3 mb-4 d-flex justify-content-between">
                              <span className="tarification-small-title" style={{ color: purchaseRemise.toFixed(0) < -12 || purchaseRemise.toFixed(0) > 0 ? 'red' : 'inherit' }}>Remise</span>
                              <span
                                className="tarification-small-title"
                                style={{ color: purchaseRemise.toFixed(0) < -12 || purchaseRemise.toFixed(0) > 0 ? 'red' : 'inherit' }}
                              >
                                {purchaseRemise.toFixed(2)} %
                              </span>
                            </div>
                            <div className="mb-4 d-flex justify-content-between">
                              <span className="tarification-small-title">TVA</span>
                              <span className="tarification-small-title">{quotation.vat} %</span>
                            </div>
                            <hr />
                          </>
                        )}


                        {isLeasingChecked && (<>
                          <div className="mb-1">
                            <div className="d-flex justify-content-between">
                              <span className="tarification-bold-title">Loyer mensuel TTC</span>
                              <span className="tarification-bold-title">{monthlyRentTTC > 0 ? `${monthlyRentTTC.toFixed(2)} €` : "-"}</span>
                            </div>
                            <div className="mt-2 d-flex justify-content-between">
                              <span className="text-muted">FAI HT</span>
                              <span className="text-muted">{quotation.fai} €</span>
                            </div>
                            <small className="text-muted">Maintenance annuelle comprise</small>
                          </div>
                        </>)}
                        {isAchatChecked && isLeasingChecked && (<hr />)}
                        {isAchatChecked && (
                          <div className="">
                            <div className="d-flex justify-content-between">
                              <span className="tarification-bold-title">Prix d'achat total TTC</span>
                              <span className="tarification-bold-title">{totalPurchaseTTC > 0 ? `${totalPurchaseTTC.toFixed(2)} €` : "-"}</span>
                            </div>
                            <div className="mt-2 d-flex justify-content-between">
                              <span className="text-muted">FAI HT</span>
                              <span className="text-muted">{quotation.fai} €</span>
                            </div>

                            <div className="mt-2 d-flex justify-content-between">
                              <span className="text-muted">Maintenance annuelle</span>
                              <span className="text-muted">{(soldPrice * 0.10).toFixed(2)} €</span>
                            </div>

                          </div>
                        )}

                      </div>
                    </>
                  )}
                  {error && <div className="alert alert-danger mt-1">{error}</div>}
                </div>
              )}
            </>
          )}

          {!loading && points.length > 0 && (
            <div className="footer shadow-lg d-flex justify-content-center">
              <button className="primary-button w-100 mb-2" onClick={handleValidate} disabled={!isLeasingChecked && !isAchatChecked}>Demander une validation</button>
              <button className="secondary-button w-100" onClick={handleDraft}>Mettre en brouillon</button>
            </div>
          )}

        </div>
      </Container>

      <Modal show={showMapModal} onHide={handleCloseMapModal} size="xl" centered dialogClassName="map-modal-full" contentClassName="map-modal-content">
        <div className="map-container">
          <div className="map-header">
            <div className="map-header-content">
              <BackButton onClick={handleCloseMapModal} className="map-back-button" />
              <div className="map-title-container mt-3">
                <h5 className="map-title">{selectedPointTitle[0]}</h5>
                <p className="map-subtitle">{selectedPointTitle[1]}</p>
              </div>
            </div>
          </div>
          <GoogleMapDisplay locations={selectedLocations} />
          <div className="map-location-counter">
            <span>{selectedLocations.length} locations</span>
          </div>
        </div>
      </Modal>
    </HelmetProvider>
  );
};

export default Summary;